// extracted by css-extract-rspack-plugin
export default {"cls1":"LoggedOutDiscoveryPage-cls1_4wJ","cls2":"LoggedOutDiscoveryPage-cls2_qLn LoggedOutDiscoveryPage-cls1_4wJ"};